// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBa5hQkIyJ_zfLWwhw_q142rNFpZ8qwtmM",
  authDomain: "ledger-management-system-6de31.firebaseapp.com",
  projectId: "ledger-management-system-6de31",
  storageBucket: "ledger-management-system-6de31.firebasestorage.app",
  messagingSenderId: "247219849834",
  appId: "1:247219849834:web:803cdf080373f6ae361813",
  measurementId: "G-ZX419PPLTG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;